import services from './services.js';
//组件
import complexSearch from './components/complex-search/index.vue';

export default {
    mixins: [services],
    components: {
        'complex-search': complexSearch
    },
    created () {
        this.getList();
    },
    data () {
        return {
            /* 主表数据 */
            loading: false,
            lists: [],//表格内容
            pageIndex: 1,
            pageSize: 10,
            totalSize: '',
            pageSizes: [10, 20, 50],
            sels: [],//列表选中
            currentId: null, //当前选中的行id

            /* 高级搜索 */
            searchVisiable: false,
            filterData: {}
        };
    },
    computed: {
        sysSid:function(){
            return this.$store.state.sysSid;
        },
        sysSession:function(){
            return this.$store.state.sysSession;
        },
        arrowClass () {
            return {
                'el-icon-arrow-down': !this.searchVisiable,
                'el-icon-arrow-up': this.searchVisiable
            };
        },
        bgStyle () {
            if (this.searchVisiable){
                return {
                    'backgroundColor': '#e8e8e8'
                };
            }
            return {
                'backgroundColor': '#fff'
            };
        }
    },
    methods: {
        selectRow (row) {
            if(!row) return;
            this.currentId = row.Id;
            this.currentStatus = row.Agent_Status;
        },
        handleSizeChange: function (val) {
            this.pageSize = val;
            this.getList();
        },
        handleCurrentChange: function (val) {
            this.pageIndex = val;
            this.getList();
        },
        toggleSearch () {
            this.searchVisiable = !this.searchVisiable;
        },
        complexSearch (data) {
            this.filterData = data;
            this.getList();
        },
        resetFilterData () {
            this.filterData = {};
        },
        agentPoorReceive () {
            if(this.currentId === null){
                this.$notify({
                    title: '警告',
                    message: '请先选择要接收的客户',
                    type: 'warning'
                });
                return;
            }
            this.$confirm('确认要接收该客户吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.req_AgentPoorReceive( {Id: this.currentId} );
            }).catch(() => {});
        }
    }
};


// WEBPACK FOOTER //
// ./src/pages/CRMagentPoor/vm.js